<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="店铺管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">StoreManagement</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush" style="position: relative">
            <div class="card-body">
              <div style="margin: 0 500px">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">

                  <el-form-item label="店铺名称" prop="companyName">
                    <el-input v-model="ruleForm.companyName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="ruleForm.tel"></el-input>
                  </el-form-item>
                  <el-form-item label="首页标题" prop="tel">
                    <el-input v-model="ruleForm.indexTitle" maxlength="7" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="首页副标题" prop="tel">
                    <el-input v-model="ruleForm.indexSubTitle" maxlength="7" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="营业时间" :rules="{required: true}">
                    <el-time-select
                        v-model="startTime"
                        placeholder="开始营业时间"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00'
                    }">
                    </el-time-select>
                    <el-time-select
                        arrow-control
                        v-model="endTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00'
                    }"
                        placeholder="结束营业时间">
                    </el-time-select>
                  </el-form-item>
                  <el-form-item label="结算模式">
                    <div v-if="$store.getters.userInfo.discount > 0">
                      固定折扣结算
                    </div>
                    <div v-else>
                      利润分配结算
                    </div>
                  </el-form-item>
                  <el-form-item label="店铺地址" prop="address">
                    <el-autocomplete style="width: 100%" :fetch-suggestions="querySearchAsync" @select="handleSelect"  v-model="ruleForm.address"  @focus="focusText" @blur="blurText"></el-autocomplete>
                  </el-form-item>
                  <el-form-item v-if="showMap">
                    <iframe style="width: 100%;height: 800px"
                            :src="'https://m.amap.com/navi/?dest='+ruleForm.location+'&destName='+ruleForm.address+'&hideRouteIcon=1&key=9ec3eded363a02c084be09a422e2f15b&jscode=37b5762b0ba53c794ed3a027ddcdc2cb'"/>
                  </el-form-item>
                </el-form>
                <div class="card-footer fixed-card-footer">
                  <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {getMyInfoApi, updateAddressApi, updateShopApi} from "@/api/userApi";
import {getInputtipsApi} from "@/api/lbsApi";

export default {
  name: 'index',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    // 这里存放数据
    return {
      ruleForm: {
        companyName: "",
        tel: "",
        address: "",
        location: "116.397273,39.909417",
        time: "",
        indexTitle: "",
        indexSubTitle: ""


      },
      rules: {
        companyName: [
          {required: true, message: '请输入店铺名称', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入店铺地址', trigger: 'blur'}
        ]
      },
      startTime: "",
      endTime: "",
      cityList: [
        {"city": "北京市", "code": "110000"},
        {"city": "天津市", "code": "120000"},
        {"city": "上海市", "code": "310000"},
        {"city": "重庆市", "code": "500000"},
        {"city": "河北省", "code": "130000"},
        {"city": "山西省", "code": "140000"},
        {"city": "内蒙古自治区", "code": "150000"},
        {"city": "辽宁省", "code": "210000"},
        {"city": "吉林省", "code": "220000"},
        {"city": "黑龙江省", "code": "230000"},
        {"city": "江苏省", "code": "320000"},
        {"city": "浙江省", "code": "330000"},
        {"city": "安徽省", "code": "340000"},
        {"city": "福建省", "code": "350000"},
        {"city": "江西省", "code": "360000"},
        {"city": "山东省", "code": "370000"},
        {"city": "河南省", "code": "410000"},
        {"city": "湖北省", "code": "420000"},
        {"city": "湖南省", "code": "430000"},
        {"city": "广东省", "code": "440000"},
        {"city": "广西壮族自治区", "code": "450000"},
        {"city": "海南省", "code": "460000"},
        {"city": "四川省", "code": "510000"},
        {"city": "贵州省", "code": "520000"},
        {"city": "云南省", "code": "530000"},
        {"city": "西藏自治区", "code": "540000"},
        {"city": "陕西省", "code": "610000"},
        {"city": "甘肃省", "code": "620000"},
        {"city": "青海省", "code": "630000"},
        {"city": "宁夏回族自治区", "code": "640000"},
        {"city": "新疆维吾尔自治区", "code": "650000"}
      ],
      cityCode: "",
      showMap: true
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    focusText(){
      this.showMap = false
    },
    blurText(){
      this.querySearchAsync()
      this.showMap = true
    },
    async querySearchAsync(queryString, cb) {
      let {data} = await getInputtipsApi({keyword: queryString});
      let geocodes = JSON.parse(data).geocodes
      this.ruleForm.location = geocodes[0].location
      cb(geocodes.map(item => {
        return {
          value: item.formatted_address,
          location: item.location
        }
      }))

    },
    handleSelect(item) {
      console.log(item.location)
      this.ruleForm.location = item.location
    },
    async myInfo() {
      let {data} = await getMyInfoApi();
      this.ruleForm.companyName = data.companyName
      this.ruleForm.tel = data.tel
      this.ruleForm.address = data.address
      this.ruleForm.indexTitle = data.indexTitle
      this.ruleForm.indexSubTitle = data.indexSubTitle
      if (data.location) {
        this.ruleForm.location = data.location
      }
      if (data.leaveTime) {
        this.startTime = data.leaveTime.split("~")[0]
        this.endTime = data.leaveTime.split("~")[1]
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!this.startTime || !this.endTime) {
          this.$message.error("请填写营业时间")
          return
        }
        this.ruleForm.time = this.startTime + "~" + this.endTime
        if (valid) {
          await updateShopApi(this.ruleForm);
          await updateAddressApi({address: this.ruleForm.address})
          this.$message.success("保存成功")
          setTimeout(() => {
            window.location.reload();
          }, 2000)
        }
      });
    },
    changeAddress(e) {
      this.ruleForm.address = this.cityList.filter(item => item.code === e).map(item => item.city)[0]
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.myInfo()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.fixed-card-footer {
  position: sticky;
  bottom: 0;
  background: white;
  padding: 15px;
  border-top: 1px solid #eee;
  z-index: 10;
  text-align: right;
}
</style>